import type { FormatXMLElementFn } from "intl-messageformat";
import type { FC, ReactNode } from "react";
import { FormattedMessage, type PrimitiveType } from "react-intl";
import type { Props } from "react-intl/src/components/message.js";

import type { messages } from "./en-US.ts";

/*
 Wrappers around react-intl components and functions, so that we can correctly type check the id
 */

type T = React.ReactNode | PrimitiveType | FormatXMLElementFn<ReactNode>;

export interface SelMessageProps extends Props<Record<string, T>> {
  id: keyof typeof messages;
  values?: Record<string, T>;
}

export const SelMessage: FC<SelMessageProps> = (props) => {
  const values = props.values ? { ...msgFormatting, ...props.values } : msgFormatting;

  return <FormattedMessage id={props.id} values={values} />;
};

const msgFormatting = {
  emph: ([chunk, ..._]: ReactNode[]) => {
    return <strong>{chunk}</strong>;
  },
};
